import * as React from 'react';
import { Checkbox } from 'antd';
import { default as styled } from 'styled-components';
import { blueLightLinearColor, transparentColor } from '@config/index';

export const NiCheckbox = styled(Checkbox)`
  .ant-checkbox {
    &.ant-checkbox-checked {
      .ant-checkbox-inner {
        background: ${blueLightLinearColor};
        border-color: ${transparentColor};
      }
    }
  }
`;
